<script lang="ts">
  import captionsState from '../../stores/captions.svelte'
</script>

{#if captionsState.state.subtitleEnabled && captionsState.state.activeCaptionCue}
  <div class="w-full text-center p-2">
    <span
      class="p-1 font-semibold font-sans"
      style:color={captionsState.state.fontColor}
      style:background-color={captionsState.state.backgroundColor}
      style:font-size={captionsState.state.fontSize}
    >
      {captionsState.state.activeCaptionCue}
    </span>
  </div>
{/if}
